export const DROPDOWN_MENU_MAX_PX = 384;

export type DropdownMenuPlacement = "up" | "down";

function getOverflowScrollParent(el: HTMLElement): HTMLElement | null {
  let node = el.parentElement;
  while (node) {
    const { overflowY } = getComputedStyle(node);
    if (/(auto|scroll|overlay)/.test(overflowY)) return node;
    node = node.parentElement;
  }
  return null;
}

function getDropdownPlacementMetrics(triggerEl: HTMLElement) {
  const rect = triggerEl.getBoundingClientRect();
  const scrollParent = getOverflowScrollParent(triggerEl);
  const containerBottom = scrollParent
    ? scrollParent.getBoundingClientRect().bottom
    : window.innerHeight;
  const containerTop = scrollParent
    ? scrollParent.getBoundingClientRect().top
    : 0;
  const spaceBelow = containerBottom - rect.bottom;
  const spaceAbove = rect.top - containerTop;
  return { spaceAbove, spaceBelow };
}

export function resolveDropdownPlacement(
  triggerEl: HTMLElement | null,
  placementProp: "auto" | "up" | "down"
): { placement: DropdownMenuPlacement; maxHeight?: number } {
  if (!triggerEl) {
    return { placement: "down" };
  }

  const { spaceAbove, spaceBelow } = getDropdownPlacementMetrics(triggerEl);

  if (placementProp === "up") {
    return {
      placement: "up",
      maxHeight: Math.min(DROPDOWN_MENU_MAX_PX, Math.max(0, spaceAbove - 8)),
    };
  }

  if (placementProp === "down") {
    return {
      placement: "down",
      maxHeight: Math.min(DROPDOWN_MENU_MAX_PX, Math.max(0, spaceBelow - 8)),
    };
  }

  if (spaceBelow < DROPDOWN_MENU_MAX_PX && spaceAbove > spaceBelow) {
    return {
      placement: "up",
      maxHeight: Math.min(DROPDOWN_MENU_MAX_PX, Math.max(0, spaceAbove - 8)),
    };
  }

  return {
    placement: "down",
    maxHeight:
      spaceBelow < DROPDOWN_MENU_MAX_PX
        ? Math.min(DROPDOWN_MENU_MAX_PX, Math.max(0, spaceBelow - 8))
        : undefined,
  };
}
